import React, {useState, useCallback, useEffect} from 'react';
import produce from 'immer';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import {SMCSelect, SMCOption} from '../../components/Simple/SMCSelect';
import SMCButton from '../../components/Simple/SMCButton';
import {validateIpAddress, validateSubnetMask, setProperty} from '../../utils/utils';
import {useSMCSnackbar} from '../../utils/hooks';
import {GatewayGetSchema} from '../../api/DBSchema/Gateway';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const topologySchema = GatewayGetSchema.pages.vpnInternalNetworkTopology.topologySchema;

// function netmask2CIDR(netmask) {
//     return netmask
//         .split('.')
//         .map(Number)
//         .map(part => (part >>> 0).toString(2))
//         .join('')
//         .split('1').length - 1;
// }

function cidrToNetmask(bitCount) {
  const mask = [];
  for(let i = 0; i < 4; i++) {
    const n = Math.min(bitCount, 8);
    mask.push(256 - Math.pow(2, 8-n));
    bitCount -= n;
  }
  return mask.join('.');
}

function InternalNetworkEditorModal({
    isOpen = false,
    onRequestClose,
    onSuccess,
    defaultObject
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();

    const [networkObject, setNetworkObject] = useState({});

    const setPageValue = useCallback((param, newValue) => {
        setNetworkObject(obj => produce(obj, draft => (
            setProperty(draft, param, newValue)
        )));
    }, []);

    const name    = networkObject[topologySchema.name];
    const network = networkObject[topologySchema.network];
    const mask    = networkObject[topologySchema.mask];

    const onFinish = () => {
        // Validate
        if (!network || !validateIpAddress(network)) {
            enqueueErrorSnackbar(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_IP', [network, t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY_WIZ.NET_ADDRESS')]), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        if (!mask || !validateSubnetMask(mask)) {
            enqueueErrorSnackbar(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_SUBNET_MASK', [mask]), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }

        onSuccess(networkObject);
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            if (defaultObject) {
                setNetworkObject(defaultObject);
            } else {
                setNetworkObject({
                    [topologySchema.name]: '',
                    [topologySchema.network]: '',
                    [topologySchema.mask]: ''
                })
            }
        }
    }, [isOpen, defaultObject]);

    return (
        <SMCModal
            isOpen={isOpen}
            width={710}
            height={480}
            title={t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY_WIZ.INTERNAL_NET_EDIT')}
            onRequestClose={onRequestClose}
        >
            <SMCModalBody>
                <SMCTextInput
                    value={name}
                    onChange={e => setPageValue(topologySchema.name, e.target.value)}
                    label={t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY_WIZ.NET_TIME')}
                />
                <SMCTextInput
                    value={network}
                    onChange={e => setPageValue(topologySchema.network, e.target.value)}
                    label={t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY_WIZ.NET_ADDRESS')}
                    />
                <SMCSelect
                    value={mask}
                    onChange={e => setPageValue(topologySchema.mask, e.target.value)}
                    label={t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY_WIZ.NET_MASK')}
                >
                    <SMCOption value={""}></SMCOption>
                    {
                        [...Array(33)].map((e,i) => (
                            <SMCOption key={i} value={cidrToNetmask(32-i)}>{cidrToNetmask(32-i)} [/{32-i}]</SMCOption>
                        ))
                    }
                </SMCSelect>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>

    );
}

export default InternalNetworkEditorModal;